import { MarkAsReadCryptoDialog } from './components/MarkedAsRead';
import { ArbitrageProviders } from './Providers';
import { ArbitrageRouter } from './Router';

export const Arbitrage = () => {
  return (
    <ArbitrageProviders>
      <ArbitrageRouter />
      <MarkAsReadCryptoDialog />
    </ArbitrageProviders>
  );
};
